function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "grip",
  d: "M3.842,9.023c-.281.843-.116,1.22-.006,1.33s.487.275,1.33-.006A7.092,7.092,0,0,0,7.784,8.615,7.091,7.091,0,0,0,9.517,6c.279-.836.119-1.214.008-1.327l0,0h0c-.111-.111-.487-.275-1.33.006A7.091,7.091,0,0,0,5.575,6.406,7.091,7.091,0,0,0,3.842,9.023Zm-1.7-.567a3.03,3.03,0,0,0,.428,3.165L13,22.053a3.03,3.03,0,0,0,3.166.428,8.86,8.86,0,0,0,3.318-2.166A8.86,8.86,0,0,0,21.65,17a3.03,3.03,0,0,0-.428-3.165h0L10.8,3.407,10.791,3.4a3.03,3.03,0,0,0-3.165-.428A8.86,8.86,0,0,0,4.307,5.138,8.86,8.86,0,0,0,2.141,8.456ZM19.954,15.1h0l-2.526-2.526v3.892h2.508l.012-.037C20.229,15.586,20.064,15.209,19.954,15.1Zm-1.039,3.16H17.428v1.487a8.925,8.925,0,0,0,1.486-1.487Zm-3.28,2.508V18.259H11.742l2.526,2.526c.11.111.487.275,1.33-.006Zm-5.8-8.3H5.947l3.892,3.892Zm1.794-5.686V10.67h3.892ZM9.052,9.883A10.614,10.614,0,0,0,9.839,9V10.67H8.173A10.62,10.62,0,0,0,9.052,9.883Zm6.582,2.581h-4v4h4Z",
  transform: "translate(-1.895 -2.726)",
  fillRule: "evenodd",
  fill: "currentColor"
});

function SvgGrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrip);
export default __webpack_public_path__ + "static/media/grip.b27b80d3.svg";
export { ForwardRef as ReactComponent };